import { GAEvent } from './events';
import { createUndefinedObject, pushDataLayer } from './utils';

interface ResourceData {
  insightId?: string | number;
  insightTitle?: string;
}

export const trackDailyInsight = async (data: ResourceData) => {
  pushDataLayer<ResourceData>(GAEvent.DAILY_INSIGHT_COMPLETED, data);
};

export const clearDailyInsightDataLayer = () => {
  const emotionDataUndefined = createUndefinedObject<ResourceData>();
  pushDataLayer<ResourceData>(`clear_${GAEvent.DAILY_INSIGHT_COMPLETED}`, emotionDataUndefined);
};
